/*
  Kriss - Lazy playback for product-grid card videos.

  The cards used to render with Liquid's `video_tag: autoplay: true`, which emits the
  largest mp4 (1080p, 2-7 MB each) and starts it immediately - including for cards
  inside a closed menu, and for every card below the fold. The front page carries 18
  of them.

  Markup side (snippets/kalis-product-grid-item.liquid) now renders preload="none"
  with a 480p source and no autoplay attribute; this file starts playback once a card
  is actually near the viewport, and pauses it again when it leaves.
*/
(function () {
  if (window.__tccGridVideo) return;
  window.__tccGridVideo = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  var saveData = !!(conn && (conn.saveData || /^(slow-)?2g$/.test(conn.effectiveType || '')));
  if (reduce || saveData) return; // poster only, nothing downloaded

  if (!('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var v = entry.target;
      if (entry.isIntersecting) {
        var p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } else if (!v.paused) {
        v.pause();
      }
    });
  }, { rootMargin: '100px' });

  function scan() {
    document.querySelectorAll('video[data-tcc-gridvideo]:not([data-tcc-seen])').forEach(function (v) {
      v.setAttribute('data-tcc-seen', '');
      io.observe(v);
    });
  }

  scan();
  document.addEventListener('DOMContentLoaded', scan);

  // Grids can arrive later (recommendations, quick shop, section rendering)
  var pending;
  new MutationObserver(function () {
    clearTimeout(pending);
    pending = setTimeout(scan, 200);
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) return;
    document.querySelectorAll('video[data-tcc-gridvideo]').forEach(function (v) {
      if (!v.paused) v.pause();
    });
  });
})();
